import React from 'react'

export default function Deliveredpackage() {
  return (
    <div>
      <section className="bgCounter wow fadeInDown">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="counter">
                <h1>0</h1>
                <h2>Delivered Packages</h2>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="counter">
                <h1>
                  99
                  <span>
                    <i className="fi fi-br-plus" />
                  </span>
                </h1>
                <h2>Countries Covered</h2>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="counter">
                <h1>
                  55
                  <span>
                    <i className="fi fi-br-plus" />
                  </span>
                </h1>
                <h2>Satisfied Clients</h2>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="counter">
                <h1>64</h1>
                <h2>Tons of Goods</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  )
}
